<template>
  <div>
    <MainHeader>

      <div class="lg:flex lg:items-center lg:justify-between">
        <!-- Left side -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center pr-4 sm:truncate">
            <h1
              class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9"
            >
              <span> Manual Import Tool </span>
            </h1>
          </div>
        </div>

        <!-- Right side  -->
        <div class="mt-5 flex lg:mt-0 lg:ml-4 space-x-2">
        </div>
      </div>

    </MainHeader>

    <div class="py-2 px-4 max-w-2xl mx-auto mt-32">
    <div class="overflow-hidden border-b border-gray-200 rounded-lg shadow">
      <div class="px-6 py-2 text-gray-500 bg-gray-50 border-b border-gray-200">
        Shopify Order Import
      </div>
      <div class="px-6 py-4 space-y-4 text-gray-500 bg-white">
        <div class="flex flex-row space-x-4">
          <div>
            <icon-fgt :name="selectedLogo" class="w-32 h-32" />
          </div>
          <div class="w-full">
            <form @submit.prevent="ImportOrder" class="space-y-4">
              <div>
                <label :for="`cart-`" class="block text-sm font-medium leading-5 text-gray-700">Cart</label>
                <select
                  :id="`cart-`"
                  v-model="cartId"
                  class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option
                    v-for="cart in carts"
                    :key="cart.ID"
                    :value="cart.ID"
                  >
                    {{ cart.CartName }}
                  </option>
                </select>
              </div>
              <div class="mt-2">
                <label :for="`order-number-${_uid}`" class="block text-sm font-medium leading-5 text-gray-700">
                  Shopify Order ID
                </label>
                <div class="relative rounded-md shadow-sm">
                  <input
                    :id="`order-number-${_uid}`"
                    v-model="orderNumber"
                    class="form-input block w-full sm:text-sm sm:leading-5"
                    placeholder="Search..."
                  />
                </div>
              </div>
              <div class="flex justify-end">
                  <Button
                    type="submit"
                    :disabled="! canImport"
                    class="flex items-center space-x-2"
                  >
                    <span>Import</span>
                    <LoadingSpinner v-if="processing" />
                  </Button>
              </div>
            </form>
          </div>
        </div>

        <HttpError :error="error" dismissable />

        <AlertSuccess header="Success" v-if="!error && pushedToQueue">
          Order {{ importedOrderNumber }} import process has started.
        </AlertSuccess>

      </div>
    </div>
  </div>


  </div>
</template>
<script>
import allCarts from "@/data/carts.json";
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import MainHeader from "@/components/elements/MainHeader.vue";

const ShoppingCarts = ApiFactory.get('shopping-carts');

export default {
  name: "ManualImport",
  data() {
    return {
      cartId: null,
      orderNumber: null,
      results: [],
      error: null,
      processing: false,
      searched: false,
      pushedToQueue: false,
      importedOrderNumber: null,
    };
  },
  components: {
    Button,
    MainHeader,
  },
  computed: {
    carts() {
      return allCarts.filter((cart) => [22, 23, 31, 32].includes(cart.ID));
    },
    selectedCart() {
      return this.carts.find((cart) => cart.ID === this.cartId);
    },
    selectedLogo() {
      return this.selectedCart?.LogoName;
    },
    canImport() {
      if (! this.orderNumber) {
        return false;
      }

      if (this.processing) {
        return false;
      }

      return !isNaN(this.orderNumber);
    }
  },
  created() {
    this.cartId = this.carts[0].ID;
  },
  mounted() {},
  methods: {
    ImportOrder() {
      this.error = null;
      this.processing = true;
      this.pushedToQueue = false;
      this.importedOrderNumber = null;

      ShoppingCarts.import(this.selectedCart?.ID, {SourceOrderNumber: this.orderNumber })
        .then((response) => {
          this.results = response.data.body;
          this.importedOrderNumber = this.orderNumber
          this.resetForm();
          this.pushedToQueue = true;
        })
        .catch((error) => this.error = error)
        .finally(() => {
          this.processing = false
          this.searched = true;
        });
    },
    resetForm() {
      this.orderNumber = null;
    },
  },
};
</script>
